import { Typography } from '@mui/material';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { COAST_VOICE_PHONE } from '../../../../env';
import { TerminalWizardPage } from '../../../../general/components/wizard-page';
import { RootState } from '../../../../store';
import { ConfirmCheck } from '../../../../theme/coast/icons';
import { VerifyAnotherCompanyButton } from '../../components/verify-another-company-button';

const completePageSelector = ({ preliminaryInfo }: RootState) => ({
  email: preliminaryInfo.info.email,
});

const FleetVerifiedPage: FC = () => {
  const { email } = useSelector(completePageSelector);

  return (
    <TerminalWizardPage
      icon={<ConfirmCheck />}
      title="You're verified!"
      subtext={
        <>
          We&apos;ve sent an email to&nbsp;
          <Typography color="primary" variant="body2" component="span">
            {email}
          </Typography>{' '}
          with instructions <br />
          on how to sign in to the customer portal.
        </>
      }
    >
      <Typography variant="body2" align="center" color="textSecondary">
        If you don&apos;t receive it within a few minutes, please call us at:
        <Typography variant="body2" component="span" color="primary">
          {COAST_VOICE_PHONE}
        </Typography>
      </Typography>
      <VerifyAnotherCompanyButton />
    </TerminalWizardPage>
  );
};

export { FleetVerifiedPage };
